import { ShowModalPayload } from './modal-manager.types';

export const CLOSE_MODAL = 'CLOSE_MODAL';

export const OPEN_MODAL = 'OPEN_MODAL';

export const closeModal = () => ({ type: CLOSE_MODAL });

export const openModal = ({
    variant,
    modalProps
}: ShowModalPayload) => ({
    type: OPEN_MODAL,
    payload: {
        variant,
        modalProps
    }
});
